import { AxiosResponse } from 'axios';
import { SET_PROJECT_EMPLOYEE_ROLES, SET_PROJECT_EMPLOYEE_ROLE, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_PROJECT_EMPLOYEE_ROLE_ISLOADING,
  DELETE_PROJECT_EMPLOYEE_ROLE,
  EDIT_PROJECT_EMPLOYEE_ROLE,
  GET_PROJECT_EMPLOYEE_ROLES,
  GET_PROJECT_EMPLOYEE_ROLE,
  REGISTER_PROJECT_EMPLOYEE_ROLE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import ProjectEmployeeRole from '@/services/project_employee_role';
import { Module } from 'vuex';
import { EditProjectEmployeeRole, RegisterProjectEmployeeRole, GetProjectEmployeeRole } from '@/dtos/project_employee_role.dto';

const projectEmployeeRole: Module<any, {}> = {
  state: {
    projectEmployeeRole: {
      data: null,
      isLoading: false,
    },
    projectEmployeeRoles: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    projectEmployeeRole: (state: { projectEmployeeRole: any }) => state.projectEmployeeRole,
    projectEmployeeRoles: (state: { projectEmployeeRoles: any }) => state.projectEmployeeRoles,
  },
  mutations: {
    [SET_PROJECT_EMPLOYEE_ROLE]: (
      state: { projectEmployeeRole: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.projectEmployeeRole.data = payload.data) : null,
        (state.projectEmployeeRole.isLoading = payload.isLoading);
    },
    [SET_PROJECT_EMPLOYEE_ROLES]: (
      state: { projectEmployeeRoles: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.projectEmployeeRoles.data = payload.data) : null,
        (state.projectEmployeeRoles.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_PROJECT_EMPLOYEE_ROLE]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT_EMPLOYEE_ROLE, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectEmployeeRole.registerProjectEmployeeRole(
        payload as RegisterProjectEmployeeRole
      );

      if (result) {
        if (result.data.status) {
          commit(SET_PROJECT_EMPLOYEE_ROLE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT_EMPLOYEE_ROLE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_EMPLOYEE_ROLE, { isLoading: false });
        return false;
      }
    },
    [GET_PROJECT_EMPLOYEE_ROLES]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT_EMPLOYEE_ROLES, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectEmployeeRole.getProjectEmployeeRoles(
        payload as GetProjectEmployeeRole
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT_EMPLOYEE_ROLES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT_EMPLOYEE_ROLES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_EMPLOYEE_ROLES, { isLoading: false });
        return false;
      }
    },
    [GET_PROJECT_EMPLOYEE_ROLE]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT_EMPLOYEE_ROLE, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectEmployeeRole.getProjectEmployeeRoles(
        payload as GetProjectEmployeeRole
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT_EMPLOYEE_ROLE, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_PROJECT_EMPLOYEE_ROLE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_EMPLOYEE_ROLE, { isLoading: false });
        return false;
      }
    },
    [EDIT_PROJECT_EMPLOYEE_ROLE]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT_EMPLOYEE_ROLE, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectEmployeeRole.editProjectEmployeeRole(
        payload as EditProjectEmployeeRole
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT_EMPLOYEE_ROLE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT_EMPLOYEE_ROLE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_EMPLOYEE_ROLE, { isLoading: false });
        return false;
      }
    },
    [DELETE_PROJECT_EMPLOYEE_ROLE]: async ({ commit }: any, payload: string) => {
      commit(SET_PROJECT_EMPLOYEE_ROLE, { data: null, isLoading: true });

      const result: AxiosResponse = await ProjectEmployeeRole.deleteProjectEmployeeRole(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT_EMPLOYEE_ROLE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT_EMPLOYEE_ROLE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT_EMPLOYEE_ROLE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_PROJECT_EMPLOYEE_ROLE_ISLOADING]: ({ commit }) => {
      commit(SET_PROJECT_EMPLOYEE_ROLE, { isLoading: false });
      commit(SET_PROJECT_EMPLOYEE_ROLES, { isLoading: false });
    },
  },
};

export default projectEmployeeRole;

